<template>
  <el-container>
    <el-scrollbar>
      <el-header class="header-top" style="height: 50px;"><s-header-top></s-header-top></el-header>
      <el-header class="header"><s-header></s-header></el-header>
      <el-main>
        <div class="content">
          <el-row type="flex" justify="space-between">
            <el-col :span="12">
              <el-breadcrumb separator-class="el-icon-arrow-right">
                <span style="float: left;">当前位置：</span>
                <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/activity' }">服务机构</el-breadcrumb-item>
              </el-breadcrumb>
            </el-col>
            <el-col :span="6">
              <el-input placeholder="输入关键字" v-model="title" @change="getActivityList"><el-button slot="append"
                  icon="el-icon-search"></el-button></el-input>
            </el-col>
          </el-row>

          <div class="page table">
            <div class="lists">
              <el-row class="item" v-for="(item, index) in activityList" :key="index">
                <el-col :span="5" class="itemImage">
                  <el-image style="width: 100%; height: 100%"
                    :src="item.image ? imgPath(item.image) : require('../../static/pro.jpg')" fit="fill"></el-image>
                </el-col>
                <el-col :span="15" class="itemList">
                  <div class="list" @click="goDetail(item)">
                    <el-row class="name">
                      <el-col :span="24" >{{ item.name }}</el-col>
                    </el-row>
                    <el-row class="label">
                      <el-col :span="24">
                        <span class="text-over-3">服务范围：{{ item.info }}</span>
                      </el-col>
                    </el-row>
                    <el-row class="label">
                      <el-col :span="24">
                        <span>联系电话：{{ item.telephone }}</span>
                      </el-col>
                    </el-row>
                    <el-row class="label">
                      <el-col :span="24">
                        <span>机构地址：{{ item.company }}</span>
                      </el-col>
                    </el-row>
                  </div>
                </el-col>

              </el-row>
            </div>
            <pagination v-show="pageTotal>0" :total="pageTotal" :page.sync="currentPage" :limit.sync="pageSize"
              @pagination="getActivityList" />
          </div>

        </div>
      </el-main>
      <el-footer class="footer"><s-footer></s-footer></el-footer>
      <el-footer class="copy-right"><s-copyRight></s-copyRight></el-footer>
    </el-scrollbar>
  </el-container>
</template>

<script>
  import sHeaderTop from '@/components/header_top';
  import sHeader from '@/components/header';
  import sFooter from '@/components/footer';
  import sCopyRight from '@/components/copy-right';
  import Pagination from '@/components/Pagination';
  import {
    personList,
    signActivity
  } from '@/api';
  export default {
    name: 'campaign',
    components: {
      sHeaderTop,
      sHeader,
      sFooter,
      sCopyRight,
      Pagination
    },
    data() {
      return {
        title: '',
        currentPage: 1,
        pageSize: 10,
        pageTotal: 0,
        activityList: []
      };
    },
    mounted() {
      if (this.$route.query.keyWord) {
        this.title = this.$route.query.keyWord;
      }
      this.getActivityList();
    },
    methods: {
      //获取列表
      getActivityList() {
        let _this = this;
        personList({
          pageNo: _this.currentPage,
          pageSize: _this.pageSize,
          title: _this.title
        }).then(res => {
          _this.activityList = res.data.list;
          _this.pageTotal = res.data.count;
        });
      },
      //跳转至详情
      goDetail(item) {
        let routeUrl = this.$router.resolve({
          path: '/personDetail', //跳转的路径
          query: {
            //路由传参时push和query搭配使用 ，作用时传递参数
            id: item.id
          }
        });
        window.open(routeUrl.href, '_blank');
      },
      //图片地址
      imgPath(oldPath) {
        return this.$imgBaseUrl + oldPath;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .page {
    min-height: 618px;
    /*若没有tabs56  height524 若有height468 */
  }

  .table {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .lists {
    width: 100%;
  }

  .item {
    width: 100%;
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #dddddd;
  }

  .itemImage,
  .itemList,
  .itemEnter {
    height: 140px;
  }

  /*左边活动图片*/
  .itemImage {
    position: relative;
  }

  .state,
  .state_close {
    position: absolute;
    right: 0;
    top: 0;
    width: 100px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background-color: #999999;
    color: #ffffff;
  }

  .state {
    background-color: #e6a23c;
  }

  /*中间信息*/
  .list {
    height: 100%;
    margin-left: 20px;
    margin-right: 20px;
    cursor: pointer;
  }

  .name {
    font-size: 17px;
  }

  .label {
    height: 20px;
    color: rgba(153, 153, 153, 1);
    font-size: 14px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .label span {
    margin-right: 20px;
  }

  /*右边报名入口*/
  .itemEnter {
    background-color: #f8f8f8;
  }

  .pay {
    margin-top: 15px;
    color: #e6a23c;
    font-size: 20px;
  }

  .follow {
    line-height: 45px;
    color: rgba(153, 153, 153, 1);
  }

  .enter,
  .enter_close {
    height: 36px;
    width: 120px;
    line-height: 36px;
    text-align: center;
    background-color: #999999;
    color: #ffffff;
    margin-top: 30px;
    border-radius: 4px;
  }

  .enter {
    background-color: #e6a23c;
    cursor: pointer;
  }

  .text-over-3 {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 4.5em; /* 设置为行高的两倍 */
    line-height: 1.5em;
  }
</style>



// WEBPACK FOOTER //
// src/views/person.vue